/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import {
  getEventId,
  getEventRetrievalExtraFieldLabel,
  getEventRetrievalExtraFieldLegend,
  getEventRetrievalExtraFieldPlaceholder,
} from '@e180/domain/lib/event/util';

import RetrieveUsernameFormDumb from './RetrieveUsernameFormDumb';
import { retrieveEmail } from 'src/shared/app/authentication/action/support/supportRetrieveUsernameActions';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => {
  const event = getEventSafely(state);

  return {
    extraFieldLegend: getEventRetrievalExtraFieldLegend(event),
    extraFieldLabel: getEventRetrievalExtraFieldLabel(event),
    extraFieldPlaceholder: getEventRetrievalExtraFieldPlaceholder(event),
    // Used in `mergeProps` only
    event,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { event } = stateProps;

  return {
    ...stateProps,
    handleSubmit({ firstName, lastName, extraData }: Object) {
      return dispatch(
        retrieveEmail(firstName, lastName, extraData, getEventId(event)),
      ).catch((e) => throwFormikSubmissionError(e));
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(RetrieveUsernameFormDumb);
